'use client'

import RouteErrorBoundary from '@/components/common/RouteErrorBoundary'

export default function CuratorPageError({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: VoidFunction
}) {
  return (
    <RouteErrorBoundary
      error={error}
      reset={reset}
      title="Error loading Curator page data"
      description="Something went wrong while loading the Curator page data. Please try again."
      homeRoute="/"
      route="/curator"
    />
  )
}
